<div class="split-tender">
  <div class="split-tender__header">
    <h2 class="split-tender__title">Split Payment</h2>
    <p class="split-tender__total">Total: <strong>{{ (totalCents / 100) | currency }}</strong></p>
  </div>

  <div class="split-tender__people">
    <span class="split-tender__people-label">Number of people</span>
    <div class="split-tender__stepper">
      <button class="split-tender__step-btn" (click)="decreasePeople()" [disabled]="numPeople <= MIN_PEOPLE">
        <i class="material-icons">remove</i>
      </button>
      <span class="split-tender__step-value">{{ numPeople }}</span>
      <button class="split-tender__step-btn" (click)="increasePeople()" [disabled]="numPeople >= MAX_PEOPLE">
        <i class="material-icons">add</i>
      </button>
    </div>
    <button class="split-tender__equal-btn" (click)="applyEqualSplit()">
      <i class="material-icons">balance</i> Split Equally
    </button>
  </div>

  <div class="split-tender__portions">
    <div class="split-tender__portion-row" *ngFor="let portion of portions; let i = index">
      <input class="split-tender__portion-label"
             type="text"
             [(ngModel)]="portion.label"
             maxlength="20"
             [attr.aria-label]="'Label for person ' + (i + 1)" />
      <div class="split-tender__portion-amount">
        <span class="split-tender__currency-symbol">$</span>
        <input class="split-tender__amount-input"
               type="number"
               min="0.01"
               step="0.01"
               [value]="getPortionDollars(i)"
               (change)="setPortionDollars(i, $any($event.target).value)"
               [attr.aria-label]="'Amount for ' + portion.label" />
      </div>
    </div>
  </div>

  <div class="split-tender__validation"
       [ngClass]="{
         'split-tender__validation--ok': remainingCents === 0,
         'split-tender__validation--over': remainingCents < 0,
         'split-tender__validation--under': remainingCents > 0
       }">
    <ng-container *ngIf="remainingCents === 0">
      <i class="material-icons">check_circle</i> Amounts match total
    </ng-container>
    <ng-container *ngIf="remainingCents > 0">
      <i class="material-icons">info</i> Remaining: {{ formatCents(remainingCents) }}
    </ng-container>
    <ng-container *ngIf="remainingCents < 0">
      <i class="material-icons">error</i> Over by {{ formatCents(-remainingCents) }}
    </ng-container>
  </div>

  <div class="split-tender__actions">
    <button class="split-tender__btn split-tender__btn--cancel" (click)="cancel()">Cancel</button>
    <button class="split-tender__btn split-tender__btn--confirm"
            [disabled]="!isValid"
            (click)="confirm()">
      Charge {{ portions[0]?.label || 'Person 1' }} First &rarr;
    </button>
  </div>
</div>
